import {Carousel} from "@mantine/carousel";
import {Box, Grid, Image, Text} from "@mantine/core";
import {useRef} from "@wordpress/element";
import Autoplay from "embla-carousel-autoplay";
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';
import {decode} from "html-entities";


const _HotSalesProduct = ({component}) => {
    const autoplay = useRef(Autoplay({ delay: 4000 }));


    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            style={{
                boxShadow: `#00000014 ${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >

            <Text
                fz="18px"
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
                lh='1'
                fw={700}
            >
                {component?.customize_properties?.label}
            </Text>
            {
                'ListViewGrid' === component.customize_properties.layout_type &&
                <Grid>
                    {
                        component?.items?.map((item, index) => (
                            <Grid.Col span={6} key={item.product_id}>
                                <Box
                                    pos="relative"
                                    mx={component?.customize_styles?.box_decoration?.margin_x}
                                    my={component?.customize_styles?.box_decoration?.margin_y}
                                    px={component?.customize_styles?.box_decoration?.padding_x}
                                    py={component?.customize_styles?.box_decoration?.padding_y}
                                    bg={component?.customize_styles?.box_decoration?.background_color}
                                    style={{
                                        boxShadow: `#00000014 ${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px`,
                                        borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                        border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                    }}
                                >

                                    <Image
                                        h={component?.customize_styles?.image_decoration?.height}
                                        w={component?.customize_styles?.image_decoration?.width}
                                        src={item?.image_url}
                                        fallbackSrc={ProductPlaceholderImage}
                                        fit="cover"
                                        // bg={component?.customize_styles?.image_decoration?.color}
                                        style={{ borderRadius: `${component?.customize_styles?.image_decoration?.radius}px` }}
                                    />
                                    <Text
                                        c={component?.customize_styles?.name_text_decoration?.color}
                                        fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                        fz={component?.customize_styles?.name_text_decoration?.font_size}
                                        fs={component?.customize_styles?.name_text_decoration?.font_style}
                                        mt={12}
                                        tt="capitalize"
                                        lh="18px"
                                        lineClamp={1}
                                        translate="yes"
                                    >
                                        {item?.name}
                                    </Text>
                                    <Text
                                        c={component?.customize_styles?.product_price_text_decoration?.color}
                                        fw={700}
                                        size={14}
                                        lh={1}
                                    >
                                        {decode(item?.currency)} {item?.discount_price ? item.discount_price : item?.price}
                                    </Text>
                                </Box>
                            </Grid.Col>
                        ))
                    }

                </Grid>
            }



            {
                'ListViewHorizontal' === component.customize_properties.layout_type &&
                <Carousel
                    slideSize="38%"
                    loop
                    slideGap={0}
                    dragFree
                    align="start"
                    withControls={false}
                    plugins={[autoplay.current]}
                    onMouseEnter={autoplay.current.stop}
                    onMouseLeave={autoplay.current.reset}
                >
                    {
                        component?.items?.map((item, index) => (
                            <Carousel.Slide
                                height={170}
                                key={index}
                                loop
                                pos="relative"
                                mx={component?.customize_styles?.box_decoration?.margin_x}
                                my={component?.customize_styles?.box_decoration?.margin_y}
                                px={component?.customize_styles?.box_decoration?.padding_x}
                                py={component?.customize_styles?.box_decoration?.padding_y}
                                bg={component?.customize_styles?.box_decoration?.background_color}
                                style={{
                                    boxShadow: `#00000014 ${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px`,
                                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                }}
                            >
                                <Image
                                    h={component?.customize_styles?.image_decoration?.height}
                                    w={component?.customize_styles?.image_decoration?.width}
                                    src={item?.image_url}
                                    fallbackSrc={ProductPlaceholderImage}
                                    fit="cover"
                                    // bg={component?.customize_styles?.image_decoration?.color}
                                    style={{ borderRadius: `${component?.customize_styles?.image_decoration?.radius}px` }}
                                />
                                <Text
                                    c={component?.customize_styles?.name_text_decoration?.color}
                                    mt={12}
                                    tt="capitalize"
                                    size={12}
                                    lh="18px"
                                    lineClamp={1}
                                    translate="yes"
                                >
                                    {item?.name}
                                </Text>
                                <Text
                                    c={component?.customize_styles?.product_price_text_decoration?.color}
                                    fw={700}
                                    size={14}
                                    lh={1}
                                >
                                    {decode(item?.currency)} {item?.discount_price ? item.discount_price : item?.price}
                                </Text>
                            </Carousel.Slide>
                        ))
                    }
                </Carousel>
            }


        </Box>
    )
}
export default _HotSalesProduct;